import { useEffect } from 'react';
import { faro } from '@grafana/faro-react';
import { UserModel } from '../api/api';

/**
 * Identifies the session in Grafana by opaque id only.
 *
 * Deliberately NO personal data: no email, no name. Grafana Cloud is a third-party store and
 * nothing that identifies a person directly may be sent there. The user id and vendor id are
 * opaque GUIDs — support can resolve them back to a person through our own systems when an
 * incident actually requires it, which keeps the personal data on our side of the boundary.
 *
 * Vendor id (rather than vendor name) is kept because failures are frequently scoped to one
 * vendor's data or permissions, and that is a dimension we slice incidents by.
 */
export default function useFaroIdentity(userId: string | null, user: UserModel | null): void {
	useEffect(() => {
		if (!faro?.api) {
			return;
		}

		if (!userId) {
			faro.api.resetUser();
			return;
		}

		faro.api.setUser({
			id: userId,
			attributes: {
				vendorId: user?.vendor?.id ?? '',
				isVendorUser: String(Boolean(user?.vendor)),
			},
		});
	}, [userId, user]);
}
